import { Component, OnInit, Input } from '@angular/core';
import { InternationalizationService } from '../services/internationalization.service';
import { ConfigurationService } from '../services/configuration.service';

@Component({
    selector: 'app-methodology-animated',
    templateUrl: './methodology-animated.component.html',
    styleUrls: [
        './methodology-animated.component.scss',
        '../../restricted/components/spiderweb-area-graph/spiderweb-area-graph.component.scss'
    ]
})
export class MethodologyAnimatedComponent implements OnInit {

    public areas: {};
    public areaIdList: Array<string> = [];
    public BrowserDetect: any;
    @Input() customClass?: string = '';
    @Input() purple: boolean = false;
    constructor(
        private internationalizationService: InternationalizationService,
        private config: ConfigurationService
    ) { }

    ngOnInit() {

        this.areas = this.config.labelAreas;
        this.areaIdList = Object.keys(this.areas);

        this.BrowserDetect = {
            init: function () {
                this.browser = this.searchString(this.dataBrowser) || "Other";
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
            },
            isMSBrowser: function (): boolean {
                this.browser = this.searchString(this.dataBrowser) || "Other";
                return this.browser.indexOf("Edge") > -1 || this.browser.indexOf("MSIE") > -1 || this.browser.indexOf("Trident") > -1;
            },
            searchString: function (data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    this.versionSearchString = data[i].subString;

                    if (dataString.indexOf(data[i].subString) !== -1) {
                        return data[i].identity;
                    }
                }
            },
            searchVersion: function (dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index === -1) {
                    return;
                }

                var rv = dataString.indexOf("rv:");
                if (this.versionSearchString === "Trident" && rv !== -1) {
                    return parseFloat(dataString.substring(rv + 3));
                } else {
                    return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
                }
            },

            dataBrowser: [
                { string: navigator.userAgent, subString: "Edge", identity: "MS Edge" },
                { string: navigator.userAgent, subString: "MSIE", identity: "Explorer" },
                { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
                { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
                { string: navigator.userAgent, subString: "Opera", identity: "Opera" },
                { string: navigator.userAgent, subString: "OPR", identity: "Opera" },

                { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
                { string: navigator.userAgent, subString: "Safari", identity: "Safari" }
            ]
        };

        this.BrowserDetect.init();
        // document.write("You are using <b>" + this.BrowserDetect.browser + "</b> with version <b>" + BrowserDetect.version + "</b>");
    }

    public getIcon(name: string): string {
        return this.config.getIcon(name);
    }
}
